import { TeamsAdministrationTeamPage } from '@features/portal-tools/sub-features/teams-administration/components/TeamsAdministrationTeamPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/teams-administration/teams/$teamId/')({
  component: RouteComponent,
})

function RouteComponent() {

    const { teamId } = Route.useParams()

    return (
        <TeamsAdministrationTeamPage teamId={teamId} />
    )
}
